import React from 'react';
import { useTranslation } from 'react-i18next';

function FullWidthImage({ src, alt, height = 'auto', overlaySrc = null, overlayAlt = '' }) {
 
  const { t } = useTranslation();

  return (
    <div
      className="relative w-full"
      style={{
        minHeight: height !== 'auto' ? height : undefined,
        height: 'auto',
      }}
    >
      {/* Immagine di Sfondo */}
      <img
        src={src}
        alt={alt}
        className="w-full object-cover"
        style={{
          minHeight: height !== 'auto' ? height : undefined,
          height: 'auto',
        }}
      />

      {/* Immagine Sovrapposta */}
      {overlaySrc && (
        <div className="absolute top-24 left-0 w-full flex justify-center">
          <img
            src={overlaySrc}
            alt={overlayAlt}
            className="w-2/3 md:w-1/2 object-contain"
          />
        </div>
      )}

  
 {/* <div className="absolute bottom-0 left-0 w-full flex justify-center">
        <div className="bg-black bg-opacity-75 w-full py-6 flex flex-col items-center gap-4">
         
          <p className="text-white text-xl text-center px-4">
            {t('add_to_wishlist')}
          </p>

          <button
            onClick={() =>
              window.open(
                'https://store.steampowered.com/app/3499700/Santherya_Uprising/',
                '_blank'
              )
            }
            className=" border border-white text-white px-8 py-4 rounded-lg flex items-center gap-3 transition duration-300 hover:bg-white hover:bg-opacity-20"
          >
            <img src="/images/Steam_Logo.png" alt="Steam" className="w-32 h-12" />
          </button>
        </div>
      </div> */}

      {/* Bottone Wishlist */}
    {/* <div className="absolute bottom-2 left-0 w-full flex justify-center">
      <button
        onClick={() => window.open('https://store.steampowered.com/app/3499700/Santherya_Uprising/', '_blank')}
        // className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-6 rounded-full shadow-lg transition duration-300"
        className="bg-dark-red text-white px-4 py-2 rounded-lg md:rounded-r-lg w-full md:w-auto flex items-center justify-center gap-2 hover:bg-white hover:bg-opacity-20"
        // className=" border border-white text-white px-8 py-4 rounded-lg flex items-center gap-3 transition duration-300 hover:bg-white hover:bg-opacity-20"
      >
     
         <img src="/images/Steam_Logo.png" alt="Steam" className="w-28 h-10" />
      </button>
    </div> */}
    </div>
  );
}

export default FullWidthImage;
